var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['centered-vertical', {container:_vm.container}],attrs:{"vertical":_vm.vertical}},[_c('div',{class:['centered-horizontal', {container:_vm.container}],attrs:{"horizontal":_vm.horizontal}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }